import * as React from 'react';

export const TargetBold = props => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.4255 10.3053C16.3406 10.3902 16.3152 10.5172 16.3559 10.6302C16.5577 11.1902 16.6735 11.791 16.6735 12.4202C16.6735 15.3592 14.2815 17.7502 11.3395 17.7502C8.39853 17.7502 6.00454 15.3592 6.00454 12.4202C6.00454 9.47522 8.39853 7.08022 11.3395 7.08022C12.044 7.08022 12.7124 7.22453 13.3269 7.47529C13.4425 7.52245 13.576 7.49878 13.6642 7.41049L15.9252 5.14865C16.0602 5.01358 16.0364 4.78819 15.872 4.69108C14.5412 3.90523 12.993 3.44922 11.3385 3.44922C6.39554 3.44922 2.37354 7.47322 2.37354 12.4202C2.37354 17.3602 6.39554 21.3802 11.3385 21.3802C16.2815 21.3802 20.3025 17.3602 20.3025 12.4202C20.3025 10.8441 19.8872 9.36801 19.1706 8.08088C19.0762 7.91133 18.8466 7.88418 18.7094 8.0214L16.4255 10.3053Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9786 9.09542C12.1414 8.93259 12.067 8.65524 11.8395 8.61962C11.6764 8.59407 11.51 8.5791 11.3399 8.5791C9.22489 8.5791 7.50488 10.3021 7.50488 12.4191C7.50488 14.5321 9.22489 16.2491 11.3399 16.2491C13.4539 16.2491 15.1739 14.5321 15.1739 12.4191C15.1739 12.3417 15.1715 12.2649 15.1668 12.1887C15.1521 11.9503 14.868 11.862 14.6991 12.031L13.0169 13.7131C12.6269 14.1041 12.1149 14.2991 11.6029 14.2991C11.0919 14.2991 10.5799 14.1041 10.1889 13.7131C9.40788 12.9331 9.40788 11.6661 10.1889 10.8851L11.9786 9.09542Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.8768 4.38953H19.8128C19.6471 4.38953 19.5128 4.25522 19.5128 4.08953V3.01953C19.5128 2.60553 19.1768 2.26953 18.7628 2.26953C18.3488 2.26953 18.0128 2.60553 18.0128 3.01953V4.70428C18.0128 4.78384 17.9812 4.86014 17.9249 4.9164L11.0728 11.7695C10.7798 12.0625 10.7798 12.5365 11.0728 12.8295C11.2198 12.9765 11.4108 13.0495 11.6038 13.0495C11.7958 13.0495 11.9868 12.9765 12.1338 12.8295L18.9849 5.97741C19.0412 5.92114 19.1175 5.88953 19.1971 5.88953H20.8768C21.2908 5.88953 21.6268 5.55353 21.6268 5.13953C21.6268 4.72553 21.2908 4.38953 20.8768 4.38953Z"
      fill="#64748B"
    />
  </svg>
);
